import { Reducer } from "redux";

import {
    PROFILE_PRODUCTS_ADD_PRODUCT_API_FAILURE,
    PROFILE_PRODUCTS_ADD_PRODUCT_API_REQUEST,
    PROFILE_PRODUCTS_ADD_PRODUCT_API_SUCCESS,
    PROFILE_PRODUCTS_REMOVE_PRODUCT_API_FAILURE,
    PROFILE_PRODUCTS_REMOVE_PRODUCT_API_REQUEST,
    PROFILE_PRODUCTS_REMOVE_PRODUCT_API_SUCCESS,
    PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_SUCCESS,
    ProfileProductsAddProductApiFailureAction,
    ProfileProductsAddProductApiRequestAction,
    ProfileProductsAddProductApiSuccessAction,
    ProfileProductsRemoveProductApiFailureAction,
    ProfileProductsRemoveProductApiRequestAction,
    ProfileProductsRemoveProductApiSuccessAction,
    ProfileProductsSearchProductsApiSuccessAction,
    SuggestedStrollerOption,
} from "@/mk2/apps/blogs/containers/ProfileProducts/ProfileProducts.actions";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

type RemovingActions =
    | ProfileProductsRemoveProductApiFailureAction
    | ProfileProductsRemoveProductApiRequestAction
    | ProfileProductsRemoveProductApiSuccessAction;

type ProfileProductsActions =
    | ProfileProductsAddProductApiFailureAction
    | ProfileProductsAddProductApiRequestAction
    | ProfileProductsAddProductApiSuccessAction
    | RemovingActions;

export interface PerProfileState {
    addingLoadingState: LoadingState;
    removingIds: string[];
}

export const perProfileInitialState: PerProfileState = {
    addingLoadingState: LoadingState.INIT,
    removingIds: [],
};

const perProfileReducer: Reducer<PerProfileState, ProfileProductsActions> = (
    state = perProfileInitialState,
    action,
) => {
    switch (action.type) {
        case PROFILE_PRODUCTS_ADD_PRODUCT_API_REQUEST:
        case PROFILE_PRODUCTS_ADD_PRODUCT_API_SUCCESS:
        case PROFILE_PRODUCTS_ADD_PRODUCT_API_FAILURE:
            return {
                ...state,
                addingLoadingState: loadingState(state.addingLoadingState, action),
            };
        case PROFILE_PRODUCTS_REMOVE_PRODUCT_API_REQUEST:
            return {
                ...state,
                removingIds: [...state.removingIds, `${action.productType}-${action.productId}`],
            };
        case PROFILE_PRODUCTS_REMOVE_PRODUCT_API_FAILURE:
        case PROFILE_PRODUCTS_REMOVE_PRODUCT_API_SUCCESS:
            return {
                ...state,
                removingIds: state.removingIds.filter(
                    (id) => id !== `${action.productType}-${action.productId}`,
                ),
            };
        default:
            return state;
    }
};

export interface State {
    profiles: {
        [username: string]: PerProfileState;
    };
    suggestedStrollerOptions: SuggestedStrollerOption[];
}

export const initialState: State = {
    profiles: {},
    suggestedStrollerOptions: [],
};

const reducer: Reducer<
    State,
    ProfileProductsActions | ProfileProductsSearchProductsApiSuccessAction
> = (state = initialState, action) => {
    switch (action.type) {
        case PROFILE_PRODUCTS_ADD_PRODUCT_API_REQUEST:
        case PROFILE_PRODUCTS_ADD_PRODUCT_API_SUCCESS:
        case PROFILE_PRODUCTS_ADD_PRODUCT_API_FAILURE:
        case PROFILE_PRODUCTS_REMOVE_PRODUCT_API_REQUEST:
        case PROFILE_PRODUCTS_REMOVE_PRODUCT_API_SUCCESS:
        case PROFILE_PRODUCTS_REMOVE_PRODUCT_API_FAILURE:
            return {
                ...state,
                profiles: {
                    ...state.profiles,
                    [action.username]: perProfileReducer(state.profiles[action.username], action),
                },
            };
        case PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_SUCCESS: {
            return {
                ...state,
                suggestedStrollerOptions: action.options,
            };
        }
        default:
            return state;
    }
};

export default reducer;
